<tt-page-heading [ttModel]="header.text" [ttTranslate]="header.translate">
    <span
        class="fa-fw"
        (click)="editing = !editing; !editing && (selectedWidget = '')"
        style="font-size: var(--tt-font-size-xl); margin-left: 0.6rem; position: relative; cursor: pointer; display: inline-block; height: var(--tt-font-size-xl)"
    >
        <span class="fa-fw fal fa-pencil" [matTooltip]="translations['edit_dashboard_layout']" matTooltipShowDelay="500" [matTooltipDisabled]="editing" style="position: absolute; top: 0"></span>
        <span *ngIf="editing" [matTooltip]="translations['stop_editing']" matTooltipShowDelay="500" class="fa-fw fal fa-slash" style="position: absolute; top: 0"></span>
    </span>
    <span
        class="fa-fw"
        (click)="dashboard?.refreshAllWidgets()"
        [matTooltip]="translations['reload_data']"
        matTooltipShowDelay="500"
        style="font-size: var(--tt-font-size-xl); margin-left: 1.8rem; position: relative; cursor: pointer; display: inline-block; height: var(--tt-font-size-xl)"
    >
        <span class="fa-fw fal fa-sync-alt" [ngClass]="{ 'fa-spin': reloadingData }" style="position: absolute; top: 0; left: 0"></span>
    </span>
</tt-page-heading>

<div style="display: flex; flex: 1; height: 100%; overflow: auto">
    <div style="flex: 1; height: 100%; overflow: auto">
        <gridstack [options]="gridOptions"></gridstack>
        <tt-webpagemenu-dashboard
            #dashboard
            style="margin-top: 3rem"
            [ttEdit]="editable && editing"
            [ttName]="ttName"
            ttArgtype="webpage_name"
            [ttArgvalue]="ttName"
            [(ttSelectedWidget)]="selectedWidget"
            [(ttReloadingData)]="reloadingData"
        ></tt-webpagemenu-dashboard>
    </div>

    <!-- <div *ngIf="selectedWidget && editable && editing" style="flex-shrink: 0; width: 35rem; height: 100%; overflow: auto">
        <tt-button-goto ttText="Gå til kpi-komponent" ttTranslateText="false" ttGoto="kpicomp" [ttGotoParms]="selectedWidget"></tt-button-goto>
        <tt-kpi-comp [kpiCompKeyno]="selectedWidget"></tt-kpi-comp>
    </div> -->
</div>
